import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import "./property.css";
import "leaflet/dist/leaflet.css";
import Breadcrumb from "../Breadcrumb/Breadcrumb";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { fetchPropertyById } from "../../redux/Slices/AddPropertySlice";
import GoogleMapPicker from "../PublishAd/GoogleMapPicker";
import {
  fetchLevels,
  fetchPropertCategories,
  fetchPropertCategoriesChilds,
  fetchPurposes,
  resetDynamicCategories,
} from "../../redux/Slices/PropertyApisSlice";
import { editProperty } from "../../redux/Slices/EditPropertySlice";
import axios from "axios";

const EditProperty = () => {
  const { t, i18n } = useTranslation("global");
  const dispatch = useDispatch();
  const { id } = useParams();
  const user3ayin = JSON.parse(sessionStorage.getItem("user3ayin"));
  const userID = user3ayin?.user?.id;
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const token = user3ayin?.token;

  const [previews, setPreviews] = useState({
    images: [null, null, null, null],
    files: [null, null, null, null],
  });
  const [showMap, setShowMap] = useState(false);
  const [subscriptionData, setSubscriptionData] = useState({});
  const [deletedImagesIds, setDeletedImagesIds] = useState([]);
  const [deletedFilesIds, setDeletedFilesIds] = useState([]);
  const [formSchema, setFormSchema] = useState([]);
  const [schemaLoading, setSchemaLoading] = useState(false);

  // ✅ Same pattern as AddProperty
  const [categoryChain, setCategoryChain] = useState([]);
  const currentCategoryId =
    categoryChain.length > 0 ? categoryChain[categoryChain.length - 1] : "";

  const navigate = useNavigate();

  const { record: propertyItem } = useSelector((state) => state.property);
  const { updateProperty, failedUpdateProperty, loadingProperty } = useSelector(
    (state) => state.edit_property
  );
  const { purposes, levels, property_categories, dynamic_categories } =
    useSelector((state) => state.properties_api);

  const [formdata, setFormData] = useState({
    purpose_id: "",
    property_level_id: "",
    category_id: "",
    title_ar: "",
    title_en: "",
    description: "",
    area: "",
    area_unit: "sqm",
    price: "",
    currency: "egp",
    payment_method: "",
    address_details: "",
    deposit_amount: "",
    images: [null, null, null, null],
    files: [null, null, null, null],
    latitude: "",
    longitude: "",
    location: "",
    AR_VR: "",
    video_url: "",
    feature_mark: "",
  });

  // ─── Initial data fetch ───────────────────────────────────────────────────
  useEffect(() => {
    dispatch(fetchPurposes());
    dispatch(fetchLevels());
    dispatch(fetchPropertCategories());
    dispatch(fetchPropertyById(id));
  }, [dispatch, i18n.language, id]);

  const fetchSchema = async (catId) => {
    if (!catId) return;
    setSchemaLoading(true);
    try {
      const res = await fetch(
        `https://app.xn--mgb9a0bp.com/api/property/form-schema?category_id=${catId}`,
        {
          headers: {
            "Content-Type": "application/json",
            Lang: i18n.language,
          },
        }
      );
      const json = await res.json();
      if (json?.data) {
        const newKeys = {};
        json.data.forEach((f) => {
          newKeys[f.key] = f.type === "switch" ? "0" : "";
        });
        setFormSchema(json.data);
        setFormData((prev) => ({ ...prev, ...newKeys }));
      } else {
        setFormSchema([]);
      }
    } catch (err) {
      console.error("Error fetching schema:", err);
      setFormSchema([]);
    } finally {
      setSchemaLoading(false);
    }
  };

  useEffect(() => {
    if (!propertyItem) return;

    setFormData((prev) => ({
      ...prev,
      purpose_id: propertyItem?.purpose?.id,
      property_level_id: propertyItem?.property_level?.id,
      category_id: propertyItem?.category?.id,
      title_ar: propertyItem?.title_ar,
      title_en: propertyItem?.title_en,
      description: propertyItem?.description,
      area: propertyItem?.area_sqm,
      area_unit: propertyItem?.area_unit || "sqm",
      price: propertyItem?.price,
      currency: propertyItem?.currency || "egp",
      payment_method: propertyItem?.payment_method,
      address_details: propertyItem?.address_details,
      deposit_amount: propertyItem?.deposit_amount,
      latitude: propertyItem?.latitude,
      longitude: propertyItem?.longitude,
      location: propertyItem?.location,
      AR_VR: propertyItem?.AR_VR,
      video_url: propertyItem?.video_url,
      feature_mark: propertyItem?.feature_mark,
    }));

    setPreviews({
      images: [
        ...(propertyItem.images || []).slice(0, 4),
        ...Array(Math.max(4 - (propertyItem.images || []).length, 0)).fill(null),
      ],
      files: [
        ...(propertyItem.files || []).slice(0, 4),
        ...Array(Math.max(4 - (propertyItem.files || []).length, 0)).fill(null),
      ],
    });
const chain = [];
  if (propertyItem?.category?.id) chain.push(propertyItem.category.id);
  if (propertyItem?.sub_category?.id) chain.push(propertyItem.sub_category.id);
  if (propertyItem?.sub_sub_category?.id) chain.push(propertyItem.sub_sub_category.id);
  setCategoryChain(chain);

  dispatch(resetDynamicCategories(0));
  if (propertyItem?.category?.id) {
    dispatch(fetchPropertCategoriesChilds({ id: propertyItem.category.id, levelIndex: 0 }));
  }
  if (propertyItem?.sub_category?.id) {
    dispatch(fetchPropertCategoriesChilds({ id: propertyItem.sub_category.id, levelIndex: 1 }));
  }
  if (propertyItem?.sub_sub_category?.id) {
    dispatch(fetchPropertCategoriesChilds({ id: propertyItem.sub_sub_category.id, levelIndex: 2 }));
  }

  // fetch schema for deepest category
  const deepestCatId =
    propertyItem?.sub_sub_category?.id ||
    propertyItem?.sub_category?.id ||
    propertyItem?.category?.id;
  fetchSchema(deepestCatId);
  }, [propertyItem, dispatch]);
  useEffect(() => {
    if (currentCategoryId) {
      fetchSchema(currentCategoryId);
    }
  }, [i18n.language]);

  useEffect(() => {
    if (!propertyItem || formSchema.length === 0) return;

    const variants = propertyItem.variants || [];
    const variantValues = {};

    variants.forEach((variant) => {
      const matchedField = formSchema.find(
        (f) => f.label?.toLowerCase() === variant.name?.toLowerCase()
      );
      if (matchedField) {
        if (matchedField.type === "switch") {
          const normalized = variant.value?.toLowerCase();
          variantValues[matchedField.key] =
            normalized === "yes" ||
            normalized === "true" ||
            normalized === "1" ||
            normalized === "نعم"
              ? "1"
              : "0";
        } else {
          const opt = matchedField.options?.find(
            (o) =>
              o.name?.toLowerCase() === variant.value?.toLowerCase() ||
              variant.value?.includes(o.name)
          );
          variantValues[matchedField.key] = opt ? opt.key : variant.value;
        }
      }
    });

    setFormData((prev) => ({ ...prev, ...variantValues }));
  }, [propertyItem, formSchema]);

  const handleDynamicCategoryChange = (levelIndex, selectedId) => {
  const newChain = [...categoryChain.slice(0, levelIndex), selectedId];
  setCategoryChain(newChain);
  setFormData((prev) => ({ ...prev, category_id: selectedId }));
  dispatch(resetDynamicCategories(levelIndex));
  dispatch(fetchPropertCategoriesChilds({ id: selectedId, levelIndex }));
  fetchSchema(selectedId);
};

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };
  const handleFileInput = (e, key) => {
    const files = Array.from(e.target.files);
    if (!files.length) return;

    const currentFiles = (formdata[key] || []).filter((f) => f !== null);
    if (currentFiles.length + files.length > 4) {
      toast.error(t("validation.You_can_upload_max_4_files"));
      e.target.value = null;
      return;
    }

    const imageTypes = ["image/jpeg", "image/png", "image/jpg"];
    const fileTypes = [
      "application/pdf",
      "application/msword",
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      "application/vnd.ms-excel",
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    ];
    const allowedTypes = key === "images" ? imageTypes : fileTypes;
    const invalidFile = files.find((f) => !allowedTypes.includes(f.type));
    if (invalidFile) {
      toast.error(
        `${t("only_allowed")} ${key === "files" ? "PDF, Word, Excel" : "JPG, JPEG, PNG"}`
      );
      e.target.value = null;
      return;
    }

    setPreviews((prev) => {
      const updated = [...prev[key]];
      files.forEach((file) => {
        const emptyIndex = updated.findIndex((f) => f === null);
        const fileObj =
          key === "images"
            ? { file, preview: URL.createObjectURL(file) }
            : { file, name: file.name };
        if (emptyIndex !== -1) updated[emptyIndex] = fileObj;
        else updated.push(fileObj);
      });
      return { ...prev, [key]: updated.slice(0, 4) };
    });

    setFormData((prev) => {
      const updated = [...prev[key]];
      files.forEach((file) => {
        const emptyIndex = updated.findIndex((f) => f === null);
        if (emptyIndex !== -1) updated[emptyIndex] = file;
        else updated.push(file);
      });
      return { ...prev, [key]: updated.slice(0, 4) };
    });

    e.target.value = null;
  };

  const removeFile = (key, index) => {
    setPreviews((prev) => {
      const updated = [...prev[key]];
      const removed = updated[index];
      if (removed?.id) {
        if (key === "images") setDeletedImagesIds((p) => [...p, removed.id]);
        else setDeletedFilesIds((p) => [...p, removed.id]);
      }
      if (removed?.preview) URL.revokeObjectURL(removed.preview);
      updated[index] = null;
      return { ...prev, [key]: updated };
    });

    setFormData((prev) => {
      const updated = [...prev[key]];
      updated[index] = null;
      return { ...prev, [key]: updated };
    });
  };

  useEffect(() => {
    const getProfileData = async () => {
      try {
        const response = await axios.get(`${BASE_URL}/api/profileData`, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
            Lang: i18n.language,
          },
        });
        setSubscriptionData(response.data.data?.user?.subscription);
      } catch (error) {
        console.error(error);
      }
    };
    getProfileData();
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (formdata.AR_VR && !formdata.AR_VR.startsWith("https://")) {
      toast.error(t("property.AR_VRLinkInvalid"));
      return;
    }
    if (formdata.video_url && !formdata.video_url.startsWith("https://")) {
      toast.error(t("property.videoLinkInvalid"));
      return;
    }
    if (!formdata.purpose_id) {
      toast.error(`${t("property.purpose")} ${t("field")} ${t("is_required")}`);
      return;
    }
    if (!formdata.category_id) {
      toast.error(`${t("property.main_categories")} ${t("field")} ${t("is_required")}`);
      return;
    }

    const data = new FormData();
    data.append("user_id", userID);
    Object.entries(formdata).forEach(([key, value]) => {
      if (["images", "files"].includes(key)) return;
      if (value !== null && value !== undefined) data.append(key, String(value));
    });
    (formdata.images || [])
      .filter((f) => f instanceof File)
      .forEach((f) => data.append("images[]", f));
    (formdata.files || [])
      .filter((f) => f instanceof File)
      .forEach((f) => data.append("files[]", f));
    deletedImagesIds.forEach((id) => data.append("deleted_images_ids[]", id));
    deletedFilesIds.forEach((id) => data.append("deleted_files_ids[]", id));

    dispatch(editProperty({ data, id }));
  };

  useEffect(() => {
    if (updateProperty) {
      toast.success(t("request_updated_success") || updateProperty, {
        onClose: () => {
          dispatch({ type: "edit_property/clearState" });
          window.location.href = "/all_properties";
        },
      });
    } else if (failedUpdateProperty) {
      const errorMessage =
    typeof failedUpdateProperty === "string"
      ? failedUpdateProperty
      : failedUpdateProperty?.message || t("failedToUpdate");

  toast.error(errorMessage, {
    onClose: () => dispatch({ type: "edit_property/clearState" }),
  });
    }
  }, [updateProperty, failedUpdateProperty, t, dispatch, navigate]);

  return (
    <div className="form_holder">
      <Breadcrumb title={t("property.edit_property_details")} />
      <div className="container">
        <div className="add_property py-4">
          <form className="form-style" onSubmit={handleSubmit}>
            <div className="row">
              <div className="col-xl-12 col-lg-12 col-md-12 col-12">
                <h4 className="fw-bold my-4 position-relative" style={{ fontSize: "22px" }}>
                  {t("property.select_category")}
                </h4>
              </div>

              {/* Purpose */}
              <div className="col-xl-4 col-lg-4 col-md-6 col-12">
                <label className="fw-bold">{t("property.purpose")}</label>
                <select name="purpose_id" onChange={handleChange} value={formdata.purpose_id}>
                  <option value="" disabled>{t("property.select_item")}</option>
                  {purposes?.map((p) => <option key={p.id} value={p.id}>{p.name}</option>)}
                </select>
              </div>

              {/* Level */}
              <div className="col-xl-4 col-lg-4 col-md-6 col-12">
                <label className="fw-bold">{t("property.level")}</label>
                <select name="property_level_id" onChange={handleChange} value={formdata.property_level_id}>
                  <option value="" disabled>{t("property.select_item")}</option>
                  {levels?.map((level) => <option key={level.id} value={level.id}>{level.name}</option>)}
                </select>
              </div>

              <div className="col-xl-4 col-lg-4 col-md-6 col-12 mb-3">
                <label className="fw-bold">{t("property.main_categories")}</label>
                <select
                  value={categoryChain[0] || ""}
                  onChange={(e) => handleDynamicCategoryChange(0, e.target.value)}
                >
                  <option value="" disabled>{t("property.select_item")}</option>
                  {property_categories?.map((cat) => (
                    <option key={cat.id} value={cat.id}>{cat.name}</option>
                  ))}
                </select>
              </div>

              {dynamic_categories.map((levelData, index) => (
                <div className="col-xl-4 col-lg-4 col-md-6 col-12 mb-3" key={index}>
                  <label className="fw-bold">{t("property.sub_categories")} {index + 1}</label>
                  <select
                    value={categoryChain[index + 1] || ""}
                    onChange={(e) => handleDynamicCategoryChange(index + 1, e.target.value)}
                  >
                    <option value="" disabled>{t("property.select_item")}</option>
                    {levelData.map((cat) => (
                      <option key={cat.id} value={cat.id}>{cat.name}</option>
                    ))}
                  </select>
                </div>
              ))}

              <div className="col-xl-12 col-lg-12 col-md-12 col-12"><hr /></div>

              {schemaLoading ? (
                <div className="col-12 text-center my-4">
                  <p className="mt-2 text-center">{t("loading_unit_features_fields")}</p>
                </div>
              ) : formSchema.length > 0 ? (
                <>
                  {formSchema.filter(field => field.type !== "switch").map((field) => (
                    <div key={field.key} className="col-xl-3 col-lg-3 col-md-6 col-12 mb-3">
                      <label className="fw-bold d-block">
                        {field.label}
                        {field.required && <span className="text-danger ms-1">*</span>}
                      </label>

                      {field.type === "numeric_input" && (
                        <input
                          type="number"
                          name={field.key}
                          value={formdata[field.key] || ""}
                          required={field.required}
                          onChange={handleChange}
                          min="0"
                          onInput={(e) => (e.target.value = e.target.value.replace(/[^0-9]/g, ""))}
                          inputMode="numeric"
                        />
                      )}
                      {field.type === "dropdown" && (
                        <select
                          name={field.key}
                          value={formdata[field.key] || ""}
                          required={field.required}
                          onChange={handleChange}
                        >
                          <option value="" disabled>{t("labels.select")} {field.label}</option>
                          {field.options.map((opt) => (
                            <option key={opt.key} value={opt.key}>{opt.name}</option>
                          ))}
                        </select>
                      )}
                    </div>
                  ))}

                  {/* Grouped switch fields (Amenities & Features) in a compact layout */}
                  {formSchema.some(field => field.type === "switch") && (
                    <>
                      <div className="col-xl-12 col-lg-12 col-md-12 col-12 mt-3 mb-2">
                        <h5 className="fw-bold text-dark">
                          {t("property.amenities_features") || "المميزات والخدمات"}
                        </h5>
                        <hr />
                      </div>
                      <div className="col-xl-12 col-lg-12 col-md-12 col-12">
                        <div className="row amenities-row">
                          {formSchema.filter(field => field.type === "switch").map((field) => (
                            <div
                              key={field.key}
                              className="col-xl-3 col-lg-3 col-md-4 col-6 mb-3"
                            >
                              <label className="amenity-toggle-card">
                                <input
                                  type="checkbox"
                                  className="amenity-toggle-input"
                                  name={field.key}
                                  checked={formdata[field.key] === "1"}
                                  onChange={(e) =>
                                    setFormData((prev) => ({
                                      ...prev,
                                      [field.key]: e.target.checked ? "1" : "0",
                                    }))
                                  }
                                />
                                <span className="amenity-toggle-label">
                                  {field.label}
                                  {field.required && (
                                    <span className="text-danger ms-1">*</span>
                                  )}
                                </span>
                                <span className="amenity-toggle-switch"></span>
                              </label>
                            </div>
                          ))}
                        </div>
                      </div>
                    </>
                  )}

                  <div className="col-xl-12 col-lg-12 col-md-12 col-12"><hr /></div>
                </>
              ) : (
                <div className="no_data bg-white py-5 border rounded-2 my-3 text-center">
                  <h5 className="mb-2 text-sm">{t("no_data_exists")}</h5>
                  <h5 className="mb-0 text-sm">{t("please_select_sub_categories_loading_unit_features_fields")}</h5>
                </div>
              )}

              {/* Property Details */}
              <div className="col-xl-12 col-lg-12 col-md-12 col-12">
                <h4 className="fw-bold my-4 position-relative" style={{ fontSize: "22px" }}>
                  {t("property.property_details")}
                </h4>
              </div>
              <div className="col-xl-6 col-lg-6 col-md-6 col-12">
                <label className="fw-bold">{t("property.unitNameAr")}</label>
                <input type="text" name="title_ar" required onChange={handleChange} value={formdata.title_ar} />
              </div>
              <div className="col-xl-6 col-lg-6 col-md-6 col-12">
                <label className="fw-bold">{t("property.unitNameEn")}</label>
                <input type="text" name="title_en" required onChange={handleChange} value={formdata.title_en} />
              </div>
              <div className="col-xl-6 col-lg-6 col-md-6 col-12">
                <label className="fw-bold">{t("property.area")}</label>
                <div className="d-flex align-items-stretch" style={{ margin: "8px 0" }}>
                  <input
                    type="number" min="0" required name="area"
                    onInput={(e) => (e.target.value = e.target.value.replace(/[^0-9]/g, ""))}
                    onChange={handleChange} value={formdata.area}
                    style={{ margin: 0, flex: 1, borderStartEndRadius: 0, borderEndEndRadius: 0 }}
                  />
                  <select
                    name="area_unit" onChange={handleChange} value={formdata.area_unit}
                    style={{
                      margin: 0,
                      width: "auto",
                      minWidth: "130px",
                      borderStartStartRadius: 0,
                      borderEndStartRadius: 0,
                      borderInlineStart: "none",
                    }}
                  >
                    <option value="sqm">{t("property.unit_sqm")}</option>
                    <option value="feddan">{t("property.unit_feddan")}</option>
                    <option value="carat">{t("property.unit_carat")}</option>
                    <option value="sahm">{t("property.unit_sahm")}</option>
                  </select>
                </div>
              </div>
              <div className="col-xl-12 col-lg-12 col-md-12 col-12"><hr /></div>
              <div className="col-xl-6 col-lg-6 col-md-6 col-12">
                <label className="fw-bold">{t("create_ad.price")}</label>
                <div className="d-flex align-items-stretch" style={{ margin: "8px 0" }}>
                  <input
                    type="number" name="price" min="0" inputMode="numeric"
                    onInput={(e) => (e.target.value = e.target.value.replace(/[^0-9]/g, ""))}
                    onChange={handleChange} value={formdata.price}
                    style={{ margin: 0, flex: 1, borderStartEndRadius: 0, borderEndEndRadius: 0 }}
                  />
                  <select
                    name="currency" onChange={handleChange} value={formdata.currency}
                    style={{
                      margin: 0,
                      width: "auto",
                      minWidth: "130px",
                      borderStartStartRadius: 0,
                      borderEndStartRadius: 0,
                      borderInlineStart: "none",
                    }}
                  >
                    <option value="egp">{t("property.currency_egp")}</option>
                    <option value="usd">{t("property.currency_usd")}</option>
                  </select>
                </div>
              </div>
              <div className="col-xl-6 col-lg-6 col-md-6 col-12">
                <label className="fw-bold">{t("property.paymentMethod")}</label>
                <select name="payment_method" onChange={handleChange} value={formdata.payment_method}>
                  <option value="" disabled>{t("property.select_item")}</option>
                  <option value="cash">{t("property.paymentCash")}</option>
                  <option value="installments">{t("property.paymentInstallments")}</option>
                  <option value="monthly">{t("property.paymentMonthly")}</option>
                </select>
              </div>
              <div className="col-xl-6 col-lg-6 col-md-6 col-12">
                <label className="fw-bold">{t("property.deposit")}</label>
                <input
                  type="number" min="0" name="deposit_amount"
                  onInput={(e) => (e.target.value = e.target.value.replace(/[^0-9]/g, ""))}
                  onChange={handleChange} value={formdata.deposit_amount}
                />
              </div>
              <div className="col-xl-12 col-lg-12 col-md-12 col-12">
                <label className="fw-bold">{t("property.detailedAddress")}</label>
                <textarea
                  name="address_details" rows={1} style={{ height: "44px", minHeight: "44px" }}
                  onChange={handleChange} value={formdata.address_details}
                  placeholder={`(${t("property.addressRegion")} - ${t("property.addressStreet")} - ${t("property.addressLandmark")})`}
                ></textarea>
              </div>

              {/* Images */}
              <div className="col-xl-12 col-lg-12 col-md-12 col-12">
                <label className="fw-bold">{t("create_ad.uploadImages")}</label>
                <div className="row">
                  {previews.images.map((img, index) => (
                    <div className="col-xl-3 col-lg-3 col-md-6 col-6" key={index}>
                      <div className="photo_wrapper">
                        <input
                          type="file" multiple accept=".png,.jpg,.jpeg"
                          onChange={(e) => handleFileInput(e, "images")}
                          disabled={formdata.images.filter((f) => f !== null).length >= 4}
                        />
                        {img ? (
                          <>
                            <img src={img.url || img.preview} alt="image" />
                            <span className="remove-file" onClick={() => removeFile("images", index)}>×</span>
                            <span className="text-sm">{t("create_ad.uploadedFile")}</span>
                          </>
                        ) : (
                          <>
                            <img src="/camera.png" alt="upload" />
                            <span className="text-sm">{t("create_ad.uploadImage")}</span>
                          </>
                        )}
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              {/* Location */}
              <div className="col-xl-12 col-lg-12 col-md-12 col-12">
                <label className="fw-bold">{t("create_ad.location")}</label>
                <input
                  type="text" name="location" value={formdata.location}
                  onChange={handleChange} required placeholder={t("create_ad.useCurrentLocation")}
                />
                <button type="button" className="btn btn-outline-primary mt-2" onClick={() => setShowMap(true)}>
                  {t("property.pickFromMap")}
                </button>
                {showMap && (
                  <div className="mt-3">
                    <GoogleMapPicker
                      onSelect={({ latitude, longitude, location }) => {
                        setFormData((prev) => ({ ...prev, latitude, longitude, location }));
                        setShowMap(false);
                      }}
                    />
                  </div>
                )}
              </div>

              {/* AR/VR */}
              {subscriptionData?.vr_tours > "0" && (
                <div className="col-xl-12 col-lg-12 col-md-12 col-12">
                  <label className="fw-bold">{t("create_ad.arVr")}</label>
                  <input
                    type="text" name="AR_VR"
                    placeholder={`${t("create_ad.link")} VR/AR`}
                    onChange={handleChange} value={formdata.AR_VR}
                  />
                </div>
              )}

              {/* Video */}
              {subscriptionData?.video === true && (
                <div className="col-xl-12 col-lg-12 col-md-12 col-12">
                  <label className="fw-bold">{t("property.video_url")}</label>
                  <input
                    type="text" name="video_url"
                    placeholder={t("create_ad.link")}
                    onChange={handleChange} value={formdata.video_url}
                  />
                </div>
              )}

              {/* Feature mark */}
              <div className="col-xl-12 col-lg-12 col-md-12 col-12">
                <label className="fw-bold">{t("property.distinctive_signs")}</label>
                <input type="text" name="feature_mark" onChange={handleChange} value={formdata.feature_mark} />
              </div>

              {/* Files */}
              <div className="col-xl-12 col-lg-12 col-md-12 col-12">
                <label className="fw-bold">{t("create_ad.additional_details")}</label>
                <div className="row">
                  {previews.files.map((file, index) => {
                    const fileIcon = file?.url?.toLowerCase().endsWith(".pdf")
                      ? "/pdf.png"
                      : file?.url?.toLowerCase().endsWith(".xls") || file?.url?.toLowerCase().endsWith(".xlsx")
                      ? "/excel.png"
                      : "/file.png";
                    return (
                      <div className="col-xl-3 col-lg-3 col-md-6 col-6" key={index}>
                        <div className="photo_wrapper">
                          <input
                            type="file" multiple accept=".pdf,.doc,.docx,.xls,.xlsx"
                            onChange={(e) => handleFileInput(e, "files")}
                            disabled={formdata.files.filter((f) => f !== null).length >= 4}
                          />
                          {file ? (
                            <>
                              <img src={fileIcon} alt="file" />
                              <span>{file.name || "Uploaded File"}</span>
                              <span className="remove-file" onClick={() => removeFile("files", index)}>×</span>
                              <span className="text-sm">{t("create_ad.uploadedFile")}</span>
                            </>
                          ) : (
                            <>
                              <img src="/camera.png" alt="upload" />
                              <span className="text-sm">{t("create_ad.uploadFile")}</span>
                            </>
                          )}
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>

              {/* Description */}
              <div className="col-xl-12 col-lg-12 col-md-12 col-12">
                <label className="fw-bold">{t("property.description")}</label>
                <textarea name="description" value={formdata.description} onChange={handleChange}></textarea>
              </div>

              {/* Submit */}
              <div className="col-xl-12 col-lg-12 col-md-12 col-12">
                <div className="form_btn">
                  <button type="submit" disabled={loadingProperty}>
                    {loadingProperty ? t("loading") : t("pages.update")}
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default EditProperty;